// extracted by mini-css-extract-plugin
export default {"nameEmailBox":"Contact_nameEmailBox__ITPtQ","inputNameEmail":"Contact_inputNameEmail__wfz3N"};